/* tslint:disable */
/* eslint-disable */
import {
  Configuration,
  InitOverrideFunction,
  RequestOpts,
} from "./gen";
import { DefaultApi } from "./gen/apis/DefaultApi";
import { CapturesApi } from "./gen/apis/CapturesApi";
import { DevicesApi } from "./gen/apis/DevicesApi";
import { FishbrainApi } from "./gen/apis/FishbrainApi";
import { SubmissionsApi } from "./gen/apis/SubmissionsApi";
import { SendersApi } from "./gen/apis/SendersApi";
import { UploadApi } from "./gen/apis/UploadApi";
import type { CaptureAnnotation } from "./gen/models/CaptureAnnotation";
import { TriageResult } from "./gen/models/TriageResult";

class DefaultApiWithAuthHandling extends DefaultApi {
  protected async request(
    context: RequestOpts,
    initOverrides?: RequestInit | InitOverrideFunction,
  ): Promise<Response> {
    try {
      return await super.request(context, initOverrides);
    } catch (error) {
      throw error;
    }
  }
}

const config = new Configuration({
  basePath: process.env.REACT_APP_API_URL ?? "",
  credentials: "include",
});

export const Api = new DefaultApiWithAuthHandling(config);
export const Captures = new CapturesApi(config);
export const Devices = new DevicesApi(config);
export const Fishbrain = new FishbrainApi(config);
export const Submissions = new SubmissionsApi(config);
export const Senders = new SendersApi(config);
export const Upload = new UploadApi(config);

export { TriageResult };
export type { CaptureAnnotation };
export * from "./gen/models/index";
